import { render } from "./ProrationInfo.vue?vue&type=template&id=2d48a98b&scoped=true"
import script from "./ProrationInfo.vue?vue&type=script&lang=js"
export * from "./ProrationInfo.vue?vue&type=script&lang=js"

import "./ProrationInfo.vue?vue&type=style&index=0&id=2d48a98b&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d48a98b"]])

export default __exports__